import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/languages/${ view }.vue`);
}

const Index = loadView( 'Index' );

const languageRoutes = [
    {
        path: 'languages',
        name: 'api.languages.getList',
        component: Index,
        meta: {
            middleware: permission,
            transitionName: 'slide',
        }
    },
];
export default languageRoutes;
